import React, { useState, useRef, useEffect } from 'react';
import './Videos.scss';
import QuickMenu from '../../components/QuickMenu/QuickMenu';

const Videos = () => {
  const [videos, setVideos] = useState([
    {
      id: 1,
      title: 'Aşırı Sıcakların Sağlık Üzerindeki Etkileri',
      src: '/assets/video/sicaklarin-saglik-uzerindeki.mp4'
    },
    {
      id: 2,
      title: 'Yeşilay Haftası Tanıtım Filmi',
      src: '/assets/video/yesilay.mp4'
    }
    // More videos can be added here as they become available
  ]);
  
  const videoRefs = useRef({});
  
  // Function to handle video loading and set the current time to the first frame
  const handleVideoLoaded = (videoId) => {
    const videoElement = videoRefs.current[videoId];
    if (videoElement) {
      // Set current time to a small value to ensure we get the first frame
      videoElement.currentTime = 0.1;
    }
  };

  return (
    <div className="videos-page">
      <div className="container">
        <div className="row">
          <QuickMenu />
          <div className="col-lg-10 col-md-7">
            <div className="videos-content">
              <h1 className="page-title mb-3">Videolar</h1>
              
              <div className="videos-grid">
                {videos.map((video) => (
                  <div className="video-item" key={video.id}>
                    <div className="video-container">
                      <video 
                        controls 
                        preload="metadata"
                        ref={el => videoRefs.current[video.id] = el}
                        onLoadedData={() => handleVideoLoaded(video.id)}
                        className="large-video-player"
                      >
                        <source src={video.src} type="video/mp4" />
                        Tarayıcınız video etiketini desteklemiyor.
                      </video>
                    </div>
                    <h3 className="video-title">{video.title}</h3>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Videos;
